class Page {
  static soribot = '/soribot';
  static my_soribots = '/my_soribots';
  static publicSharePage = '/share'; // Public external sharing.
  static publicBotPage = '/b'; // Standalone Soribot page.
  static ai_memo = '/ai-memo'; // AI Memo & Meeting Minutes.
  static feedback = '/feedback'; // Bug Report & Feedback.
  static board = '/board'; // Board (게시판).
  static calendar = '/calendar'; // Calendar (캘린더).
  static files = '/files'; // File Management (파일관리).
}

export default Page;